/* @ngInject */
const perDayOptions = (
  utils,
  excelStyles,
  types,
) => {
  const self = {}

  self.generateOptions = (_options) => {
    const options = utils.copy(_options)
    options.filename = 'invoicing_linear'
    options.enableColor = true
    options.firstRow = 7
    options.rowHeight = 17
    options.getHeaderData = self.getHeaderData
    options.getFooterData = self.getFooterData
    options.getBodyData = self.getBodyData
    options.getResumeData = self.getResumeData
    options.getResumeHeaderData = self.getResumeHeaderData
    options.getInvoiceData = self.getInvoiceData
    options.lastRow = options.wagons.length + options.firstRow
    options.firstRowResume = 5

    return options
  }

  self.getHeaderData = ({ wagons, invoice, }) => {
    return [{
      name: 'D2',
      value: 'Propriétaire',
      style: excelStyles.invoiceHeaderGrey,
      mergeRange: 'D2:E2',
    }, {
      name: 'D3',
      value: invoice.owner.society,
      style: excelStyles.invoiceHeaderGrey,
      mergeRange: 'D3:E4',
    }, {
      name: 'G2',
      value: 'Période',
      style: excelStyles.invoiceHeaderGrey,
      mergeRange: 'G2:H2',
    }, {
      name: 'G3',
      value: 'Du : ',
      style: excelStyles.invoiceHeaderGrey,
    }, {
      name: 'G4',
      value: 'Au : ',
      style: excelStyles.invoiceHeaderGrey,
    }, {
      name: 'H3',
      value: invoice.dateBegin,
      type: types.date,
      style: excelStyles.invoiceHeaderGrey,
    }, {
      name: 'H4',
      value: invoice.dateEnd,
      type: types.date,
      style: excelStyles.invoiceHeaderGrey,
    }, {
      name: 'I2',
      value: 'Mois',
      style: excelStyles.invoiceHeaderGrey,
    }, {
      name: 'I3',
      value: '=H4',
      style: excelStyles.invoiceHeaderGrey,
      mergeRange: 'I3:I4',
    }, {
      name: 'L2',
      value: 'Nombre total de wagon',
      style: excelStyles.invoiceHeaderGrey,
      mergeRange: 'L2:M2',
    }, {
      name: 'L3',
      value: wagons.length,
      type: types.integer,
      style: excelStyles.invoiceHeaderGrey,
      mergeRange: 'L3:M4',
    }, {
      name: 'B5',
      value: 'N° Wagon',
      style: excelStyles.invoiceHeaderOrange,
      mergeRange: 'B5:B6',
    }, {
      name: 'C5',
      value: 'Type',
      style: excelStyles.invoiceHeaderOrange,
      mergeRange: 'C5:C6',
    }, {
      name: 'D5',
      value: 'Mètre linéaire',
      style: excelStyles.invoiceHeaderOrange,
      mergeRange: 'D5:D6',
    }, {
      name: 'E5',
      value: 'Entré le',
      style: excelStyles.invoiceHeaderOrange,
      mergeRange: 'E5:E6',
    }, {
      name: 'F5',
      value: 'Sorti le',
      style: excelStyles.invoiceHeaderOrange,
      mergeRange: 'F5:F6',
    }, {
      name: 'G5',
      value: 'Dégarage',
      style: excelStyles.invoiceHeaderOrange,
      mergeRange: 'G5:G6',
    }, {
      name: 'H5',
      value: 'Séjour',
      style: excelStyles.invoiceHeaderOrange,
      mergeRange: 'H5:H6',
    }, {
      name: 'I5',
      value: 'Occupation (m)',
      style: excelStyles.invoiceHeaderOrange,
      mergeRange: 'I5:I6',
    }, {
      name: 'J5',
      value: 'Coût / Wagon / Jour',
      style: excelStyles.invoiceHeaderOrange,
      mergeRange: 'J5:K5',
    }, {
      name: 'J6',
      value: invoice.wagonCost,
      type: types.euro,
      style: excelStyles.invoiceHeaderOrange,
      mergeRange: 'J6:K6',
    }, {
      name: 'L5',
      value: 'Coût Dégarage',
      style: excelStyles.invoiceHeaderOrange,
    }, {
      name: 'L6',
      value: invoice.unparkCost,
      style: excelStyles.invoiceHeaderOrange,
    }, {
      name: 'M5',
      value: 'Mise à dispo INEO sur VA',
      style: excelStyles.invoiceHeaderOrange,
      mergeRange: 'M5:O5',
    }, {
      name: 'M6',
      value: 'NB - PU :',
      style: excelStyles.invoiceHeaderOrange,
    }, {
      name: 'N6',
      value: invoice.provisionCost,
      style: excelStyles.invoiceHeaderOrange,
    }, {
      name: 'O6',
      value: 'Date',
      style: excelStyles.invoiceHeaderOrange,
    }, {
      name: 'L5',
      value: 'Dégarage',
      style: excelStyles.invoiceHeaderOrange,
      mergeRange: 'L5:L6',
    }, {
      name: 'P5',
      value: 'Coût total / wagon',
      style: excelStyles.invoiceHeaderOrange,
    }, {
      name: 'Q5',
      value: `Imputation ${invoice.owner.society}`,
      style: excelStyles.invoiceHeaderOrange,
      mergeRange: 'Q5:R6',
    }, {
      name: 'S5',
      value: 'Informations diverses',
      style: excelStyles.invoiceHeaderOrange,
      mergeRange: 'S5:V6',
    },]
  }

  self.getBodyData = (wagon, { currentRow, firstRow, lastRow, }) => {
    return [{
      name: 'A' + currentRow,
      value: currentRow - firstRow + 1,
      type: types.integer,
      style: excelStyles.invoiceHeader,
    }, {
      name: 'B' + currentRow,
      value: wagon.id,
      type: types.wagonId,
    }, {
      name: 'C' + currentRow,
      value: wagon.type,
      type: types.text(),
    }, {
      name: 'D' + currentRow,
      value: wagon.length,
      type: types.decimal,
    }, {
      name: 'E' + currentRow,
      value: wagon.arrivalDate,
      type: types.date,
    }, {
      name: 'F' + currentRow,
      value: wagon.departureDate,
      type: types.date,
    }, {
      name: 'G' + currentRow,
      value: `=IF(OR(F${currentRow}="", F${currentRow}="-"), 0, 1)`,
      type: types.integer,
    }, {
      name: 'H' + currentRow,
      value: `=IF(E${currentRow} > H$3,
        IF(G${currentRow} > 0, F${currentRow} - E${currentRow}, H$4 - E${currentRow}),
        IF(G${currentRow} > 0, F${currentRow} - H$3, H$4 - H$3)) + 1`,
      type: types.integer,
    }, {
      name: 'I' + currentRow,
      value: `=D${currentRow} * H${currentRow}`,
      type: types.decimal,
    }, {
      name: 'J' + currentRow,
      value: `=H${currentRow} * $J$6`,
      type: types.euro,
      mergeRange: `J${currentRow}:K${currentRow}`,
    }, {
      name: 'L' + currentRow,
      value: `=G${currentRow} * $L$6`,
      type: types.euro,
    }, {
      name: 'M' + currentRow,
      value: `=IF(OR(ISBLANK(O${currentRow}), O${currentRow} = ""),0,LEN(O${currentRow})-LEN(SUBSTITUTE(O${currentRow},CHAR(10),""))+1)`,
      type: types.integer,
    }, {
      name: 'N' + currentRow,
      value: `=M${currentRow} * $N$6`,
      type: types.euro,
    }, {
      name: 'O' + currentRow,
      value: `${wagon.dispositionDates}`,
      style: excelStyles.wrapText,
    }, {
      name: 'P' + currentRow,
      value: `=K${currentRow} + L${currentRow} + N${currentRow} + J${currentRow}`,
      type: types.euro,
      style: excelStyles.invoiceHeader,
    }, {
      name: `Q${currentRow}`,
      mergeRange: `Q${currentRow}:R${currentRow}`,
    }, {
      name: 'S' + currentRow,
      mergeRange: `S${currentRow}:V${currentRow}`,
    },]
  }

  self.getFooterData = ({ invoice, wagons, firstRow, }) => {
    const rowIndex = wagons.length + firstRow + 1
    const lastRow = wagons.length + firstRow
    return [{
      name: 'B' + rowIndex,
      value: 'Longueur utilisée',
      style: excelStyles.invoiceHeader,
    }, {
      name: 'B' + (rowIndex + 1),
      value: `=SUM(D${firstRow}:D${lastRow})`,
      type: types.decimal,
    }, {
      name: 'E' + (rowIndex + 1),
      value: 'Total',
      style: excelStyles.invoiceHeader,
      mergeRange: `E${rowIndex + 1}:F${rowIndex + 1}`,
    }, {
      name: 'E' + (rowIndex + 2),
      value: 'Moyenne',
      style: excelStyles.invoiceHeader,
      mergeRange: `E${rowIndex + 2}:F${rowIndex + 2}`,
    }, {
      name: 'G' + rowIndex,
      value: 'Dégarages',
      style: excelStyles.invoiceHeader,
    }, {
      name: 'G' + (rowIndex + 1),
      value: `=SUM(G${firstRow}:G${lastRow})`,
      type: types.integer,
    }, {
      name: 'G' + (rowIndex + 2),
      value: `=AVERAGE(G${firstRow}:G${lastRow})`,
      type: types.decimal,
    }, {
      name: 'H' + rowIndex,
      value: 'Occupation',
      style: excelStyles.invoiceHeader,
    }, {
      name: 'H' + (rowIndex + 1),
      value: `=SUM(H${firstRow}:H${lastRow})`,
      type: types.integer,
    }, {
      name: 'H' + (rowIndex + 2),
      value: `=AVERAGE(H${firstRow}:H${lastRow})`,
      type: types.decimal,
    }, {
      name: 'I' + rowIndex,
      value: 'Linéaire occupé',
      style: excelStyles.invoiceHeader,
    }, {
      name: 'I' + (rowIndex + 1),
      value: `=SUM(I${firstRow}:I${lastRow})`,
      type: types.decimal,
    }, {
      name: 'I' + (rowIndex + 2),
      value: `=AVERAGE(I${firstRow}:I${lastRow})`,
      type: types.decimal,
    }, {
      name: 'J' + rowIndex,
      value: 'Coût / Wagon / Jour',
      style: excelStyles.invoiceHeader,
      mergeRange: `J${rowIndex}:K${rowIndex}`,
    }, {
      name: 'J' + (rowIndex + 1),
      value: `=SUM(J${firstRow}:J${lastRow})`,
      type: types.euro,
      mergeRange: `J${rowIndex + 1}:K${rowIndex + 1}`,
    }, {
      name: 'J' + (rowIndex + 2),
      value: `=AVERAGE(J${firstRow}:J${lastRow})`,
      type: types.euro,
      mergeRange: `J${rowIndex + 2}:K${rowIndex + 2}`,
    }, {
      name: 'L' + rowIndex,
      value: 'Coûts dégarages',
      style: excelStyles.invoiceHeader,
    }, {
      name: 'L' + (rowIndex + 1),
      value: `=SUM(L${firstRow}:L${lastRow})`,
      type: types.euro,
    }, {
      name: 'L' + (rowIndex + 2),
      value: `=AVERAGE(L${firstRow}:L${lastRow})`,
      type: types.euro,
    }, {
      name: 'M' + rowIndex,
      value: 'MàD',
      style: excelStyles.invoiceHeader,
    }, {
      name: 'M' + (rowIndex + 1),
      value: `=SUM(M${firstRow}:M${lastRow})`,
      type: types.integer,
    }, {
      name: 'M' + (rowIndex + 2),
      value: `=AVERAGE(M${firstRow}:M${lastRow})`,
      type: types.decimal,
    }, {
      name: 'N' + rowIndex,
      value: 'MàD €',
      style: excelStyles.invoiceHeader,
    }, {
      name: 'N' + (rowIndex + 1),
      value: `=SUM(N${firstRow}:N${lastRow})`,
      type: types.euro,
    }, {
      name: 'N' + (rowIndex + 2),
      value: `=AVERAGE(N${firstRow}:N${lastRow})`,
      type: types.euro,
    }, {
      name: 'P' + rowIndex,
      value: 'Coût total',
      style: excelStyles.invoiceHeader,
    }, {
      name: 'P' + (rowIndex + 1),
      value: `=SUM(P${firstRow}:P${lastRow})`,
      type: types.euro,
    }, {
      name: 'P' + (rowIndex + 2),
      value: `=AVERAGE(P${firstRow}:P${lastRow})`,
      type: types.euro,
    }, {
      name: 'E' + (rowIndex + 4),
      value: 'TOTAL À FACTURER : ',
      style: excelStyles.invoiceTotal,
      mergeRange: `E${rowIndex + 4}:H${rowIndex + 6}`,
    }, {
      name: 'I' + (rowIndex + 4),
      value: `=SUM(P${firstRow}:P${lastRow})`,
      type: types.euro,
      mergeRange: `I${rowIndex + 4}:J${rowIndex + 6}`,
      style: excelStyles.invoiceTotal,
    },]
  }

  self.getResumeHeaderData = ({ invoice, wagons, firstRowResume, }) => {
    return [{
      name: `B${firstRowResume}`,
      value: 'N° Wagon',
      style: excelStyles.invoiceHeader,
    }, {
      name: `C${firstRowResume}`,
      value: 'Type',
      style: excelStyles.invoiceHeader,
    }, {
      name: `D${firstRowResume}`,
      value: 'Coût du wagon',
      style: excelStyles.invoiceHeader,
    }, {
      name: `E${firstRowResume}`,
      value: 'Imputation ' + invoice.owner.society,
      style: excelStyles.invoiceHeader,
      mergeRange: `E${firstRowResume}:F${firstRowResume}`,
    }, {
      name: `D${wagons.length + firstRowResume + 1}`,
      value: `=SUM(D${firstRowResume + 1}:D${wagons.length + firstRowResume})`,
      style: excelStyles.invoiceHeader,
      type: types.euro,
    },]
  }

  self.addDeliveryTimeout = (date) => {
    date = utils.date.stringToDate(date)
    date.date(15)
    date.month(date.month() + 2)
    return utils.date.dateToString(date)
  }

  self.getResumeData = ({ currentRow, wagons, firstRow, firstRowResume, }) => {
    const wagon = wagons[currentRow]
    const rowIndex = currentRow + firstRowResume + 1
    return [{
      name: `A${rowIndex}`,
      value: currentRow + 1,
      type: types.integer,
      style: excelStyles.invoiceHeader,
    }, {
      name: `B${rowIndex}`,
      value: wagon.id,
      type: types.wagonId,
    }, {
      name: `C${rowIndex}`,
      value: wagon.type,
      type: types.euro,
    }, {
      name: `D${rowIndex}`,
      value: `='Detail'!P${currentRow + firstRow}`,
      type: types.euro,
      style: excelStyles.invoiceHeader,
    }, {
      name: `E${rowIndex}`,
    }, {
      name: `F${rowIndex}`,
    },]
  }

  self.getInvoiceData = ({ invoice, wagons, firstRow, }) => {
    const rowIndex = wagons.length + firstRow + 1
    const owner = invoice.owner
    const deliveryDate = self.addDeliveryTimeout(invoice.dateBegin)
    return [{
      name: 'F3',
      value: invoice.owner.society,
      style: excelStyles.noStyle,
    }, {
      name: 'F5',
      value: invoice.dateEnd,
      type: types.date,
      style: excelStyles.noStyle,
    }, {
      name: 'E7',
      value: `${owner.society}`,
      style: excelStyles.noStyle,
    }, {
      name: 'E8',
      value: `${owner.address}`,
      style: excelStyles.noStyle,
    }, {
      name: 'E10',
      value: `${owner.cp} ${owner.city} ${owner.country}`,
      style: excelStyles.noStyle,
    }, {
      name: 'B17',
      value: invoice.dateBegin,
      type: types.date,
      style: excelStyles.noStyle,
    }, {
      name: 'D17',
      value: invoice.dateEnd,
      type: types.date,
      style: excelStyles.noStyle,
    }, {
      name: 'G19',
      value: `='Detail'!J${rowIndex + 1} + 'Detail'!K${rowIndex + 1}`,
      type: types.euro,
      style: excelStyles.noStyle,
    }, {
      name: 'G21',
      value: `=B23*B24`,
      type: types.euro,
      style: excelStyles.noStyle,
    }, {
      name: 'B23',
      value: `='Detail'!G${rowIndex + 1} + 'Detail'!M${rowIndex + 1}`,
      type: types.integer,
      style: excelStyles.noStyle,
    }, {
      name: 'B24',
      value: invoice.unparkCost,
      type: types.euro,
      style: excelStyles.noStyle,
    }, {
      name: 'G28',
      value: `=G19 + G21`,
      type: types.euro,
      style: excelStyles.noStyle,
    }, {
      name: 'G29',
      value: `=G28 * E29`,
      type: types.euro,
      style: excelStyles.noStyle,
    }, {
      name: 'G30',
      value: `=G29 + G28`,
      type: types.euro,
      style: excelStyles.noStyle,
    }, {
      name: 'B33',
      value: deliveryDate,
      type: types.euro,
      style: excelStyles.noStyle,
    },]
  }

  return self
}
export default perDayOptions



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/invoice/perDayOptions.resource.js